import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const Bwa = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={t`Current BWA`}
      documentType="management accounts"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          <Trans>
            You can download BWA from your accounting software or ask your tax
            advisor
          </Trans>
        </li>
        <li>
          <Trans>
            All BWAs should show company name, sales revenue, purchases of
            goods, costs including depreciation, interest expenses & preliminary
            results
          </Trans>
        </li>
      </ul>
    </DocumentRequirement>
  );
};
